
/**
 * Player API Config
 * Used to pass in the base URL
 */
export class PlayerApiConfig {
  public apiUrl = 'https://api.splixer.com/player_api/v1/';
}
